import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class AuthService {

    static login(item) {
        return axiosInstance.post(API_BASE_URL + API_PATHS.adminlogin, item)
            .then((response) => {
                if (response?.data && response?.data?.status === 1) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("accessToken", response.data.data.accessToken);
                    localStorage.setItem("refreshToken", response.data.data.refreshToken);
                    return response.data;
                } else {
                    // If the login attempt was unsuccessful, throw an error
                    throw new Error(response?.data?.message || 'Invalid credintials');
                }
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }



    static forgotPassword(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.forgotPassword}`;
        return axiosInstance
            .post(api, item)
    }

    static setPassword(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.verifyOtpAndSetPassword}`;
        return axiosInstance
            .post(api, item)
    }



    static getProfile() {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.getProfile}`;

        return axiosInstance.get(api)
    }



    static getStats(item) {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.orggetStats}?range=${item.range}&orgId=${item.orgId}`;

        return axiosInstance
            .get(api)

    }



    static getCounts(item) {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.orggetDashCount}?range=${item.range}&orgId=${item.orgId}`;

        return axiosInstance
            .get(api)

    }



    // Method to remove user details from localStorage
    static removeUserDetails() {
        localStorage.removeItem('user');
    }

    // Method to get user details from localStorage
    static getUserDetails() {
        const user = localStorage.getItem('user');
        try {
            return user ? JSON.parse(user) : "";
        } catch (e) {
            console.error('Error parsing user details from localStorage', e);
            return null;
        }
    }

    // Method to set tokens in localStorage
    static setTokens(data) {
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken)
    }
}

export default AuthService;
